import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalMoKhoa } from "./ModalMoKhoa";

export const BtnMoKhoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Mở khoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i class="mdi mdi-lock-open-variant"></i>
        </PopoversBootrap>
      </a>
      {show && (
        <ModalMoKhoa
          show={show}
          onHide={handleClose}
          Id={item.Id}
          item={item}
        />
      )}
    </>
  );
};
